import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5cba751e&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=5cba751e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba751e",
  null
  
)

export default component.exports